// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"_33eG9","lines":"_1gb2-","shadow":"tdEE1","lineClamp":"_2dh8L"};